import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';

export default function Blog() {

	useEffect(() => {
		document.title = "Blog Page: RedPanda Fencing"
	}, []);	

	return <div style={{textAlign:"center"}}> 
	
	<h1>RedPanda Website Draft</h1> 
	<br></br>
	<p>Work in Progress</p> 
	
	
	<br></br>
	<Link to="/">This page</Link>
	<br></br> 
	<Link to="/tbt">Touch By Touch Fencing App</Link>
	<br></br>
	<Link to="/feedback">Feedback and Suggestions.</Link>
	<br></br>
	<Link to="/aboutus">About Us Page</Link>
	<br></br>
	<Link to="/blog">Blog</Link>
	<br></br>
	<Link to="/contactus">Contact Us</Link>
	<br></br>
	<Link to="/fencingcamp">Red Panda fencing camp.</Link>
	<br></br>
	
	
	
	</div> 
	



}